import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayFilter',
  pure: false
})
export class FilterPipe implements PipeTransform {
  transform(items: any[], filter: any): any {

    if (!items || !filter || !filter.value) {
      return items;
    }
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    // if(items[0] is object)
    return items.filter(item => {
      let found = true;
      const value = filter.value;
      if (filter.field) {
        const key = filter.field;
        if (item[key] && found) { found = found && item[key].indexOf(value) !== -1; }
      } else {
        if (item && found) { found = found && item.indexOf(value) !== -1; }
      }
      return found;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/filter.pipe.ts